import { MinimalAlert, MinimalButton } from '@ovasabi/ui-minimal'
import { ChowModal } from '../../components/chow'
import { useChefOrderDetail } from '../choosechow/chefOrderState'
import { formatNaira, type Row } from './opsData'
import * as S from './OpsStyle'

export const OpsOrderDetail = ({ orderId, onClose }: { orderId: string; onClose: () => void }) => {
  const { detail, loading, error, retry } = useChefOrderDetail(orderId)
  const order = detail?.order as Row | undefined
  const items = (detail?.items ?? []) as Row[]
  return <ChowModal open title="Order details" onClose={onClose}>
    {loading && <p role="status">Loading order…</p>}
    {error && <MinimalAlert tone="danger" title="Order unavailable">{error}<MinimalButton onClick={retry}>Retry</MinimalButton></MinimalAlert>}
    {order && <>
      <S.CardTitle>{String(order.id).slice(0, 8)} · {String(order.status).replace(/_/g, ' ')}</S.CardTitle>
      <p>{String(detail?.customer_name || 'Customer')} · {String(detail?.customer_phone || 'No phone')}</p>
      <p>{order.delivery_choice === 'self_pickup' ? `Pickup: ${String(order.pickup_address || detail?.pickup_address || 'Address unavailable')}` : String(detail?.dropoff_address || 'No delivery address')}</p>
      {order.scheduled_at && <p>Scheduled: {String(order.scheduled_at)}</p>}
      <S.TableScroll><S.Table><thead><tr><th>Dish</th><th>Quantity</th><th>Total</th></tr></thead><tbody>
        {items.map((item, index) => <tr key={String(item.item_ref ?? index)}><td>{String(item.item_name)}{item.special_instructions ? <p>{String(item.special_instructions)}</p> : null}</td><td>{Number(item.quantity)}</td><td>{formatNaira(Number(item.line_total_minor))}</td></tr>)}
      </tbody></S.Table></S.TableScroll>
      <p>Food: {formatNaira(Number(order.subtotal_minor))}</p>
      <p>Discount{order.promo_code ? ` · ${String(order.promo_code)}` : ''}: −{formatNaira(Number(detail?.discount_applied_minor ?? 0))}</p>
      <p>Service fee: {formatNaira(Number(order.service_fee_minor ?? 0))}</p>
      {Number(order.delivery_fee_minor) > 0 && <p>Delivery fee: {formatNaira(Number(order.delivery_fee_minor))}</p>}
      {Number(detail?.chef_promo_discount_minor) > 0 && <p>Chef-funded discount: {formatNaira(Number(detail?.chef_promo_discount_minor))}</p>}
      <strong>Total: {formatNaira(Number(order.total_minor))}</strong>
    </>}
  </ChowModal>
}
